import { AYUDA_HIDE, AYUDA_SHOW } from "../ActionTypes";

const ayuda = (state, { type }) => {
  switch (type) {
    case AYUDA_SHOW:
      return {
        ayuda: {
          show: true,
        },
      };
    case AYUDA_HIDE:
      return {
        ayuda: {
          show: false,
        },
      };
    default:
      return state;
  }
};

export default ayuda;
